import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { applyWebViewLanguage } from '../utils/webviewUtils';
import { sanitizeHtmlContent } from '../utils/imageUtils';
import apiService from '../services/api_service';
import './StaticPage.css';

function Contact() {
    const { t, i18n } = useTranslation();
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // WebView için dil ayarlarını uygula
    useEffect(() => {
        applyWebViewLanguage(i18n.changeLanguage);
    }, [i18n]);

    // API'den sayfa verilerini getir
    const fetchPageData = async (language) => {
        try {
            setLoading(true);
            setError(null);

            const response = await apiService.getStaticPage('contact', language);
            // API response'u data objesi içinde geliyor
            setPageData(response.data);
        } catch (err) {
            console.error('Error fetching contact page:', err);
            setError(apiService.handleError(err));
        } finally {
            setLoading(false);
        }
    };

    // İlk yükleme ve dil değişikliğinde API'yi çağır
    useEffect(() => {
        fetchPageData(i18n.language);
    }, [i18n.language]);

    // Loading durumu
    if (loading) {
        return (
            <div className="static-page-wrapper">
                <div className="static-container">
                    <div className="loading-section">
                        <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                        <p>{t('staticPage.loading')}</p>
                    </div>
                </div>
            </div>
        );
    }

    // Hata durumu
    if (error) {
        return (
            <div className="static-page-wrapper">
                <div className="static-container">
                    <div className="error-section">
                        <h2>{t('staticPage.errorTitle')}</h2>
                        <p>{error}</p>
                        <button
                            onClick={() => fetchPageData(i18n.language)}
                            className="retry-button"
                        >
                            {t('staticPage.retry')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Sayfa verisi yoksa fallback içerik göster
    if (!pageData || !pageData.content) {
        return (
            <div className="static-page-wrapper">
                <div className="static-container">
                    <div className="hero-section">
                        <h1 className="gradient-title">{t('contact.hero.title')}</h1>
                        <p className="hero-description">
                            {t('contact.hero.description')}
                        </p>
                    </div>
                    <div className="error-section">
                        <p>{t('staticPage.loadFailed')}</p>
                    </div>
                </div>
            </div>
        );
    }

    // HTML içeriğini güvenli hale getir ve görsel yollarını düzelt
    const sanitizedContent = sanitizeHtmlContent(pageData.content);

    return (
        <div className="static-page-wrapper">
            <div className="static-container">
                {/* API'den gelen HTML içeriği güvenli şekilde render et */}
                <div
                    dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                    className="api-content"
                />
            </div>
        </div>
    );
}

export default Contact;
